var plugin_rtlignore_default = {
  "alignLeft": "TOC1W",
  "textWrapNowrap": "UCqKL",
  "alignRight": "mburm",
  "alignCenter": "KbuM0",
  "sizeFullWidth": "UpJtQ",
  "renderedInTable": "fyAwy",
  "sizeOriginal": "fFa73",
  "sizeContent": "Zpl-B",
  "sizeSmall": "NbuUX",
  "sizeSmallCenter": "pauRc",
  "flex": "-zdOg",
  "atomic": "BWffR",
  "embed": "_1IwOW",
  "horizontalScrollbar": "lY2eB",
  "pluginContainerMobile": "_2mQgr"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
